import gridRow from './grid/Row.vue';

export default {
    components: { gridRow },
    props: [ 'json', 'displaysize' ]
}



/** WEBPACK FOOTER **
 ** ./src/components/Panel.js
 **/